// FILE: lib/notifications/types/index.ts
// ── Registry trung tâm: Import tất cả loại notification ──

export type NotificationType =
  | "diamond_topup"
  | "diamond_earned"
  | "diamond_purchase"  // ← THÊM
  | "withdraw"
  | "new_follower"
  | "badge_earned"
  | "exam_approved"
  | "review_liked"
  | "system";

export interface NotificationConfig {
  type: NotificationType;
  icon: string;        // Emoji icon
  color: string;       // Tailwind bg color class cho badge
  defaultTitle: string; // Fallback title
}

// Map config cho từng loại — UI component sẽ đọc từ đây
export const NOTIFICATION_CONFIGS: Record<NotificationType, NotificationConfig> = {
  diamond_topup:  { type: "diamond_topup",  icon: "💎", color: "bg-orange-500", defaultTitle: "Nạp kim cương thành công" },
  diamond_earned: { type: "diamond_earned", icon: "✨", color: "bg-yellow-500", defaultTitle: "Nhận kim cương" },
  diamond_purchase: { type: "diamond_purchase", icon: "🛒", color: "bg-red-500", defaultTitle: "Mua nội dung" },
  withdraw:       { type: "withdraw",       icon: "💰", color: "bg-green-500",  defaultTitle: "Rút tiền" },
  new_follower:   { type: "new_follower",   icon: "👤", color: "bg-blue-500",   defaultTitle: "Người theo dõi mới" },
  badge_earned:   { type: "badge_earned",   icon: "🏆", color: "bg-purple-500", defaultTitle: "Nhận huy hiệu mới" },
  exam_approved:  { type: "exam_approved",  icon: "✅", color: "bg-teal-500",   defaultTitle: "Đề thi được duyệt" },
  review_liked:   { type: "review_liked",   icon: "❤️", color: "bg-pink-500",   defaultTitle: "Review được thích" },
  system:         { type: "system",         icon: "📢", color: "bg-slate-500",  defaultTitle: "Thông báo hệ thống" },
};
